import { render, staticRenderFns } from "./TravelAndAllowance.vue?vue&type=template&id=6cb1872e"
import script from "./TravelAndAllowance.vue?vue&type=script&lang=js"
export * from "./TravelAndAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports